import {
  maintenanceAccessCode,
  maintenanceAccessCodeKey,
} from 'constants/MaintenanceConfig';

const checkHasAccessDuringMaintenanceMode = () => {
  const code = localStorage.getItem(maintenanceAccessCodeKey);

  return code === maintenanceAccessCode;
};

export { checkHasAccessDuringMaintenanceMode };
